import * as React from "react";
import { SVGProps } from "react";
const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.21 10.76c2.1 1.8 5.2 1.7 7.1-.4 1.8-2.1 1.7-5.2-.4-7.1-2.1-1.9-5.2-1.7-7.1.4-1.3 1.5-1.7 3.7-.8 5.5l-5.2 3.1c-2-1.9-5.2-1.7-7.1.4-1.9 2.1-1.7 5.2.4 7.1 1.9 1.7 4.8 1.7 6.7 0l5.2 3.1c-1.2 2.5-.1 5.5 2.4 6.7 2.5 1.2 5.5.1 6.7-2.4 1.2-2.5.1-5.5-2.4-6.7-.7-.3-1.5-.5-2.2-.5-1.2 0-2.4.5-3.3 1.3l-5.2-3.1c.7-1.3.7-2.9 0-4.3l5.2-3.1Zm3.3-6.8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3Zm-13 15c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3Zm13 9c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShare;
